function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import SVG from "../../layouts/SVG.js";
export var AlmosaferWhite = function AlmosaferWhite(props) {
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 9.3881V9.37451C23.9539 9.38372 21.4723 10.8242 18.2618 12.7888V18.6447C18.2618 18.7705 18.1666 18.872 18.0491 18.872H8.34421C3.78851 21.6703 0.000244141 23.9999 0.000244141 23.9999H23.6059C23.8257 23.9999 24.0024 23.8095 24 23.5746V9.3881Z",
    fill: "#0C9AB0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6058 4.09692H6.34741L12.9526 9.22485H18.049C18.1665 9.22485 18.2618 9.32641 18.2618 9.45215V12.7889C21.4722 10.8242 23.9538 9.38398 24 9.37454V4.51813C24 4.28553 23.8237 4.09692 23.6058 4.09692Z",
    fill: "#EF4550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74231 18.6447V9.45215C5.74231 9.32664 5.83735 9.22485 5.9548 9.22485H12.9527L6.34746 4.09692H0.394171C0.176504 4.09692 0 4.28553 0 4.51813V24C0 24 3.78848 21.6706 8.34418 18.872H5.9548C5.83735 18.872 5.74231 18.7705 5.74231 18.6447Z",
    fill: "#003143"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0739 2.05905C10.0739 1.93308 10.1693 1.83106 10.2874 1.83106H13.7218C13.8397 1.83106 13.9352 1.93308 13.9352 2.05905V3.48778H15.6839V0.420745C15.6839 0.188149 15.5078 0 15.2901 0H8.71012C8.49245 0 8.31616 0.188149 8.31616 0.420745V3.48663H10.0739V2.05905Z",
    fill: "#EF4550"
  }));
};